module.exports = __webpack_public_path__ + "static/media/cert_100-tc.4bce0c18.jpg";